<template>
  <div class="wrapper">
    <div class="my-inbox" ref="box" @click.prevent="">
      <div class="item" v-for="(item, index) in menuItems" :key="index" :id="index" :style="getStyle(index)"
        @click.prevent="clickMenuItem(index, $event)">
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lz-menu",
  props: {
    menuItems: Array,
    checkedIndex: {
      type: Number,
      default: 0
    },
    iColor: {
      type: String, //未选中文本颜色
      default: "#1D1D1D"
    },
    iBgColor: {
      //未选中背景色
      type: String,
      default: "#EFEFF2"
    },
    iActiveColor: {
      //选中时文本颜色
      type: String,
      default: "#140047"
    },
    iActiveBgColor: {
      //选中时背景色
      type: String,
      default: "#140047"
    }
  },
  // data() {
  //   return {
  //     currentIndex: 1
  //   };
  // },
  // beforeMount() {
  //   //挂着前，修改默认选项
  //   this.currentIndex = this.DefaultIndex;
  // },

  methods: {
    getStyle(index) {
      console.log("checkedIndex: " + this.checkedIndex);
      const select = index == this.checkedIndex
      if (select) {
        return {
          color: select ? this.iActiveColor : this.iColor,
          background: select ? this.iActiveBgColor : this.iBgColor
        };
      } else {
        return {
          color: select ? this.iActiveColor : this.iColor,
          background: select ? this.iActiveBgColor : this.iBgColor,
          opacity: 0.3
        };
      }
    },
    clickMenuItem(idx, event) {
      let inbox = this.$refs.box;

      // 点击事件传递给调用者
      if (this.checkedIndex != idx) {
        console.log("点击index: " + idx);
        this.$emit("clickLzMenuItem", { ...this.menuItems[idx], index: idx });
      }

      //滚动 到中间
      let e = event.currentTarget;
      let left = e.offsetLeft - inbox.clientWidth / 2 + e.offsetWidth / 2;
      inbox.scrollLeft = left;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  margin-top: 4vw;
  margin-bottom: 4vw;
  width: 100%;

  .my-inbox {
    overflow-y: hidden;
    overflow-x: scroll;
    width: 100%;
    white-space: nowrap;

    .item {
      display: inline-block;
      height: 2rem;
      font-size: 0.75rem;
      line-height: 2rem;
      margin: 0.5rem;
      padding: 0px 0.8rem;
      text-align: center;
      color: red;
      border-radius: 0.8rem;
    }

    .active {
      background-color: #036875;
      font-weight: bold;
      border-radius: 25px;
      color: #fff;
    }
  }

  .my-inbox::-webkit-scrollbar {
    width: 0.5em;
    /* 设置滚动条宽度 */
    height: 0.5em;
    /* 设置滚动条高度 */
  }

  .my-inbox::-webkit-scrollbar-thumb {
    background-color: transparent;
    /* 将滚动条拇指颜色设置为透明 */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LzMenu.vue